import displayDate from 'bcl/helpers/display-date';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import sort from 'bcl/helpers/sort';
import eq from 'ember-truth-helpers/helpers/eq';
import setElement from 'bcl/modifiers/set-element';

interface InputSelectStocktakingSignature {
  // The arguments accepted by the component
  Args: {
    // The name of the input field
    name: string;
    // The label for the input field
    label: string;
    // The value of the input field, expected to be a supplier model
    value: { id: string; name: string };
    // Callback function to handle changes in the select input
    onChange?: (value: { id: string; name: string }) => void;
    // Force update trigger, can be used to refresh the component
    forceUpdate?: number;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class InputSelectStocktakingComponent extends Component<InputSelectStocktakingSignature> {
  <template>
    {{! this is used to set the select to the correct value }}
    {{this._forceUpdate}}
    <div
      class="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-2 col-span-6"
    >
      <label
        for={{@name}}
        class="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5 sm:text-right"
      >{{@label}}</label>
      <div class="mt-2 sm:col-span-2 sm:mt-0">
        <select
          {{on "change" this.change}}
          {{setElement this.inserted}}
          name={{@name}}
          id={{@name}}
          value={{@value}}
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6"
        >
          {{#each (sort this.stocktakings "-created_at") as |stocktaking|}}
            <option
              value={{stocktaking.id}}
              selected={{eq stocktaking @value}}
            >{{displayDate stocktaking.created_at}}</option>
          {{/each}}
        </select>
      </div>
    </div>
  </template>
  @service store;
  element: HTMLSelectElement;
  @action
  change(event: Event) {
    if (this.args.onChange) {
      const value = event.target.value;
      this.element = event.target as HTMLSelectElement;
      const model = this.store.peekRecord('stocktaking', value);
      this.args.onChange(model);
      // this.args.onChange(...arguments);
    }
  }
  get stocktakings() {
    return this.store.peekAll('stocktaking');
  }
  @action inserted(element: HTMLSelectElement) {
    const val = element.value;
    if (val) {
      const model = this.store.peekRecord('stocktaking', element.value);
      this.args.onChange(model);
    }
  }
  get _forceUpdate() {
    // entangle this.args.forceUpdate;
    this.args.forceUpdate;
    if (this.element) {
      this.element.value = this.args.value.id;
    }
    return null;
  }
}
